import { useNavigate } from 'react-router-dom';
import classes from './bdportalLanding.module.scss';
import opportunityIcon from 'assets/icons/oppertunity-tracker.svg';
import productWiki from 'assets/icons/product-wiki.svg';
import bidAnalysisIcon from 'assets/icons/bidAnalysis.svg';
import { screenDataInterface } from 'Interfaces/navigationScreenDataInterface';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';

const BDPortalLanding = () => {
  const navigate = useNavigate();
  const { FeatureFlagStore } = useStore();

  const flagEnabled = (key: string) => !FeatureFlagStore.isLoaded || FeatureFlagStore.isEnabled(key);

  const screenData: screenDataInterface = [
    {
      location: '/bdportal/optracker/board',
      img: opportunityIcon,
      label: 'Opportunity Tracker',
      disabled: !flagEnabled('bdportal.opportunity_tracker'),
    },
    {
      location: '/bdportal/product-wiki',
      img: productWiki,
      label: 'Product Wiki',
      disabled: !flagEnabled('bdportal.product_wiki'),
    },
    {
      location: '/bdportal/bid-analysis',
      img: bidAnalysisIcon,
      label: 'Bid Analysis',
      disabled: !flagEnabled('bdportal.bid_analysis'),
    },
  ];

  return (
    <div className={classes.bdPortalScreen}>
      {screenData.filter(data => !data.disabled).map((data, index) => (
        <div onClick={() => navigate(data.location)} key={index}>
          <div className={classes.btnSection}>
            <div>
              <div className={classes.imgBackground}></div>
              <img
                src={data.img}
                alt={`${data.label} icon`}
                className={data.label === 'Bid Analysis' ? classes.bidAnalysisIcon : undefined}
              />
            </div>
            <p>{data.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(BDPortalLanding);
